import React from 'react';

export default function FwPersonIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-male' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
